// In src/components/Section.js
import React from "react";
import "./Content.css";
import "../styles/colors.css";
// unused import removed
import imageGalc250 from "../assets/gal-c250.jpg";
import imageAluminiumteil from "../assets/aluminium-zeichnungsteil.jpg";
import imagePlattenZuschnitte from "../assets/platten-zuschnitte-300x300-1-1.jpg";
import imageCNCFertigung from "../assets/cnc-fertigung-300x300-1.jpg";
import imageBeratung from "../assets/oberflaechenbehandlung-300x300-1.jpg";
import mekoLogo from "../assets/MEKO_LOGO.svg";
import ResponsiveImage from "./ResponsiveImage";
import Counter from "./Counter";
import ContactForm from "./ContactForm";

const Content = ({ locale, deviceType }) => {
  return (
    <>
      <div
        className="container-fluid hero-section"
        style={{ margin: 0, marginTop: 0, padding: 0 }}
      >
        <div>
          <a href="/">
            <img
              src={mekoLogo}
              alt="MEKO Logo"
              style={{ position: "absolute " }}
              className="hero-logo-badge"
            />
          </a>
        </div>
        <div className="hero-headlines hero-text-wrapper">
          <h1 className="hero-headline-1 text-center">
            Aluminium Zuschnitte & CNC-Bearbeitung für Unternehmen in Österreich
          </h1>
          <h2 className="hero-headline-2 text-center">
            Maßgenaue Aluminiumbearbeitung – schnell, zuverlässig und persönlich betreut
          </h2>
          <p className="hero-text">
              Wir fertigen Aluminium-Zuschnitte und CNC-Bauteile nach Ihren Vorgaben – vom Einzelteil bis zur Serie.
              Beschreiben Sie uns Ihren Bedarf – wir melden uns kurzfristig mit einer passenden Lösung.
            </p>
            <div className="text-center">
              <div className="button button-red">
              <a
                href="#anfragen"
                rel="noreferrer"
                target="_self"
                id="hero"
              >
                Jetzt Bedarf anfragen
              </a>
            </div>
            </div>
           
        </div>
      </div>
      <div className="container">
        <div className="row section">
          <div className="col-md-12">
            <div className="headline-subline-wrap">
              <h2 className=" headline-2 text-uppercase">
                Ihr Partner für Aluminium in Österreich
              </h2>
              <h3 className="headline-3">
                Persönliche Betreuung durch unser Verkaufsbüro in Österreich –
                von der Beratung bis zur Umsetzung
              </h3>
            </div>
          </div>
          <div className="col-md-7 mt-md-5">
            <p className="copy">
              Mit unserem Verkaufsbüro für Österreich betreuen wir Unternehmen
              in allen Bundesländern – von Wien über Oberösterreich bis
              Vorarlberg.
            </p>
            <p className="copy">
              Unsere Kunden profitieren von kurzen Kommunikationswegen,
              persönlicher Beratung und fundierter Marktkenntnis.
            </p>
            <ul className="check-list">
              <li>
                Betreuung österreichischer Kunden durch feste Ansprechpartner
              </li>
              <li>Erfahrung aus zahlreichen Projekten im DACH-Raum</li>
              <li>Zuverlässige Umsetzung nach höchsten Qualitätsstandards</li>
            </ul>
          </div>
          <div className="col-md-5 text-center mt-md-5">
            <div className="col-image">
              <ResponsiveImage
                src={imageAluminiumteil}
                alt="Aluminiumteil Bild"
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center section">
          <div className="col-md-12">
            <div className="button button-red">
              <a
                href="#anfragen"
                rel="noreferrer"
                target="_self"
                id="bedarf-anfragen-1"
              >
                Jetzt Bedarf für Österreich anfragen
              </a>
            </div>
            <p style={{ marginTop: 30 }}>Unverbindlich und kostenlos</p>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row section bgBlue key-figures-section">
          <div className="col-12">
            <div className="container content-container">
              <div className="row">
                <div className="col-md-12 text-white">
                  <p className="key-figure-text">
                    GLEICH Aluminium gehört auf dem globalen Aluminium
                    Präzisionsplatten Markt aufgrund seiner weltweit
                    einzigartigen Produktion mit einer eigenen, elektrisch
                    betriebenen Wärmebehandlungsanlage zu den führenden
                    Produzenten.
                  </p>
                </div>
              </div>
              <div className="row text-center text-white key-figures-row">
                <div className="col-md-3 col-6">
                  <div className="key-figure-number">
                    <Counter end={20000} duration={2.5} /> t
                  </div>
                  <div className="key-figure-label">Tonnen G.AL® Aluminium</div>
                </div>
                <div className="col-md-3 col-6">
                  <div className="key-figure-number">
                    <Counter end={75} duration={2.5} /> +
                  </div>
                  <div className="key-figure-label">Millionen Umsatz</div>
                </div>
                <div className="col-md-3 col-6">
                  <div className="key-figure-number">
                    <Counter end={150} duration={2.5} /> +
                  </div>
                  <div className="key-figure-label">Mitarbeiter</div>
                </div>
                <div className="col-md-3 col-6">
                  <div className="key-figure-number">
                    <Counter end={0.03} duration={3} decimals={2} />%
                  </div>
                  <div className="key-figure-label">Reklamationsquote</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row align-items-center section">
          <div className="col-md-12">
            <div className="headline-subline-wrap">
              <h2 className=" headline-2 text-uppercase">Unsere PRODUKTE</h2>
              <h3 className="headline-3">Aluminium in Premium Qualität</h3>
            </div>
          </div>
          <div className="col-md-12">
            <p className="copy">
              Seit mehr als 45 Jahren bieten wir unter dem Markennamen G.AL®
              verschiedenen Legierungen an, die durch einen hochautomatisierten
              Fertigungsprozess und eine weltweit einzigartige
              Einezlbarren-Wärmebehandlung einen qualitativen Benchmark am Markt
              darstellen. Dadurch haben Sie Material zur Verfügung, mit dem Sie
              die Ausschussquoten deutlich reduzieren können, ihre Prozesskosten
              senken können und damit zufriedene Kunden haben.
            </p>
          </div>
          <div className="col-md-7">
            <p className="copy">
              Unsere G.AL® Aluminium-Gussplatten setzen Maßstäbe in Bezug auf
            </p>
            <ul className="check-list">
              <li>Spannungsarmut</li>
              <li>Ebenheit</li>
              <li>Festigkeit</li>
              <li>gleichbleibende Qualität</li>
            </ul>
          </div>
          <div className="col-md-5 text-center">
            <div className="col-image">
              <ResponsiveImage src={imageGalc250} alt="Galc250 Bild" />
            </div>
          </div>
        </div>
        <div className="row align-items-center section">
          <div className="col-md-12">
            <div className="button button-red">
              <a
                href="https://gleich.de/de/produkte/"
                rel="noreferrer"
                target="_blank"
                id="produkte"
              >
                Mehr Informationen zu unseren Produkten
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row section">
          <div className="col-md-12">
            <div className="headline-subline-wrap">
              <h2 className=" headline-2 text-uppercase">Unsere Leistungen</h2>
              <h3 className="headline-3">für Kunden in Österreich</h3>
            </div>
          </div>
          <div className="col-md-12">
            <p className="copy">
              Wir unterstützen Kunden aus Industrie, Maschinenbau und Handwerk
              mit passgenauen Aluminium-Lösungen – exakt nach Bedarf.
            </p>
          </div>
          <div className="col-md-4">
            <div className="col-wrapper">
              <div className="col-image">
                <ResponsiveImage
                  src={imagePlattenZuschnitte}
                  alt="Platten und Zuschnitte Bild"
                  boxShadow={true}
                />
              </div>
              <h4 className="headline-4">Aluminiumplatten und Zuschnitte</h4>
              <p className="copy">
                Maßgenaue Aluminium-Zuschnitte nach Ihren Anforderungen –
                flexibel, präzise und termingerecht geliefert nach Österreich.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="col-wrapper">
              <div className="col-image">
                <ResponsiveImage
                  src={imageCNCFertigung}
                  alt="CNC Fertigung Bild"
                  boxShadow={true}
                />
              </div>
              <h4 className="headline-4">CNC Fertigung von Aluminium</h4>
              <p className="copy">
                CNC-Bearbeitung von Aluminium für maßgenaue Aluminium Frästeile. Fertigung nach Zeichnung – vom Einzelstück bis zur Serie.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="col-wrapper">
              <div className="col-image">
                <ResponsiveImage
                  src={imageBeratung}
                  alt="Beratung Bild"
                  boxShadow={true}
                />
              </div>
              <h4 className="headline-4">Persönliche Beratung für Aluminium-Bauteile</h4>
              <p className="copy">
                Sie planen ein Bauteil aus Aluminium? Wir unterstützen Sie bei Materialauswahl, Zuschnitt und CNC-Bearbeitung und entwickeln gemeinsam mit Ihnen eine passende Lösung.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row section">
          <div className="col-md-12">
            <div className="headline-subline-wrap">
              <h2 className=" headline-2 text-uppercase">
                Darum entscheiden sich Unternehmen
              </h2>
              <h3 className="headline-3"> in Österreich für uns</h3>
            </div>
          </div>
          <div className="col-md-6">
            <p className="copy">
              Unsere Kunden schätzen die Kombination aus technischer Kompetenz
              und verlässlicher Betreuung.
            </p>
            <ul className="check-list">
              <li>Langjährige Erfahrung im Aluminium Bereich</li>
              <li>Zuverlässige Lieferfähigkeit nach Österreich</li>
              <li>Persönliche Beratung statt anonymer Prozesse</li>
              <li>Hohe Qualitäts- und Sicherheitsstandards</li>
            </ul>
          </div>
          <div className="col-md-6">
            <p className="copy">
              MEKO Metallkomponenten Ges.m.b.H. <br />
              Ein Unternehmen der GLEICH Gruppe <br />
              Triester Straße 447a <br />
              A- 8055 Graz
              <br />
              <a href="tel:+43316296959">+43 (0) 316 296 959</a> <br />
              <a href="tel:+4331629695910">+43 (0) 316 296 959 10</a> <br />
              <a href="mailto:info@meko.at">info@meko.at</a>
            </p>
          </div>
          <div className="row align-items-center section">
            <div className="col-md-12">
              <div className="button button-red">
                <a
                  href="#anfragen"
                  rel="noreferrer"
                  target="_self"
                  id="bedarf-anfragen-2"
                >
                  Jetzt Bedarf für Österreich anfragen
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row section bgBlue key-figures-section">
          <div className="col-12">
            <div className="container content-container">
              <div className="row">
                <div className="col-md-12 text-center text-white">
                  <div className="video-responsive-wrapper">
                    <iframe
                      src="https://www.youtube-nocookie.com/embed/_tR2BBuKvzU?si=jNMx7lXjhzuVQAmp"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container" id="anfragen">
        <p class="copy copy-contact-form" >
        Sie benötigen Aluminium-Zuschnitte oder CNC-gefräste Aluminiumteile?<br />
        Stellen Sie jetzt eine unverbindliche Anfrage.
        </p>
        <ContactForm />
      </div>
    </>
  );
};

export default Content;
